import { useRouter } from 'next/router';
import {
  Dialog, DialogContent, DialogActions, IconButton,
} from '@mui/material';
import { CheckCircle, Error, Close } from '@mui/icons-material';

interface Props {
  imported: string[];
  importId?: string;
  username: string;
  onClose: () => void;
}

export const ShowFinish = ({
  username, imported = [], onClose, importId,
}: Props) => {
  const router = useRouter();

  const viewImport = () => {
    const query = importId
      ? {
        importId, ownership: 'imported', creditedStatus: 'all', newImport: 'true',
      }
      : { postingAccount: username, sort: 'postedAt' };

    onClose();

    router.push({
      pathname: '/explore',
      query,
    });
  };

  const renderTable = () => (
    <table>
      <thead className="font-bold border-b">
        <tr>
          <td className="py-2">URL</td>
          <td>Status</td>
        </tr>
      </thead>
      <tbody>
        {imported.map((row: any) => (
          <tr key={row?.url} className="border-b">
            <td className="py-2 pr-6">
              {row?.url}
            </td>
            <td>
              {!row?.error ? (
                <>
                  <CheckCircle color="secondary" />
                  {' '}
                  Success!
                  {' '}
                </>
              ) : (
                <>
                  <Error className="align-middle" color="error" />
                  {' '}
                  {row.error}
                </>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );

  return (
    <Dialog onClose={onClose} aria-labelledby="title" open maxWidth="lg">
      <div className="absolute right-2 top-2">
        <IconButton aria-label="close" onClick={onClose}>
          <Close />
        </IconButton>
      </div>
      <DialogContent>
        {renderTable()}
      </DialogContent>
      <DialogActions>
        <button type="button" className="btn-primary" onClick={viewImport}>
          View Imported Posts
        </button>
      </DialogActions>
    </Dialog>
  );
};
